import { Link, useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useApp } from "@/lib/store";

export default function RfqDrawer() {
  const { items, remove, clear, open, setOpen } = useApp();
  const nav = useNavigate();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="rfq-drawer" className="bg-[var(--paper)] w-full sm:max-w-md flex flex-col">
        <SheetHeader>
          <p className="eyebrow">Enquiry list</p>
          <SheetTitle className="serif text-3xl font-medium">Your RFQ basket</SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto mt-6 divide-y divide-[var(--stone)]">
          {items.length === 0 && <p data-testid="rfq-empty" className="text-sm text-[var(--graphite)] py-6">No products yet. Use "Add to enquiry" on any product to build a consolidated request.</p>}
          {items.map((i, idx) => (
            <div key={`${i.slug}-${idx}`} data-testid={`rfq-item-${i.slug}`} className="flex gap-4 py-4 items-center">
              <img src={i.image} alt="" className="w-16 h-16 object-contain prod-bg border border-[var(--stone)]" />
              <div className="flex-1 min-w-0">
                <Link to={`/products/${i.category}/${i.slug}`} onClick={() => setOpen(false)} className="serif text-lg leading-tight block hover:text-[var(--brass)]">{i.name}</Link>
                {(i.variant || i.finish) && <p className="text-xs text-[var(--graphite)]">{[i.variant, i.finish].filter(Boolean).join(" · ")}</p>}
              </div>
              <button aria-label="Remove" data-testid={`rfq-remove-${i.slug}`} onClick={() => remove(idx)} className="text-[var(--steel)] hover:text-[#A33A2B] transition-colors"><Trash2 size={16} /></button>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div className="border-t border-[var(--stone)] pt-5 space-y-3">
            <button data-testid="rfq-proceed" className="btn btn-brass w-full" onClick={() => { setOpen(false); nav("/enquiry?from=basket"); }}>Proceed to enquiry ({items.length})</button>
            <button data-testid="rfq-clear" className="text-xs text-[var(--graphite)] hover:text-[var(--ink)] w-full" onClick={clear}>Clear list</button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
